import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
    position: relative;
    width: 100%;
    padding: 2em 0;

    .headline {
        font-size: 1.1em;
        font-weight: 700;
    }

    .list {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        align-items: center;
        padding-top: 1.6em;

        .list-element {
            padding: .5em 2em;
            border: .1em solid #000000;
            border-radius: 3.3em;
            margin: 1em 1.6em 0 0;

            &:last-of-type {
                margin-right: 0;
            }
        }
    }

    @media all and (max-width: ${variables.mobileM}) {
        font-size: 120%;

        .list {
            .list-element {
                margin: 1em 1em 0 0;
            }
    }
`;